<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="costCenter.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveCostCenter()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !costCenter['deleted']"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteCostCenter()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && costCenter['deleted']"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreCostCenter()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
